import { render } from "./Multiselect.vue?vue&type=template&id=956df6d6&scoped=true&ts=true"
import script from "./Multiselect.vue?vue&type=script&lang=ts"
export * from "./Multiselect.vue?vue&type=script&lang=ts"

import "./Multiselect.vue?vue&type=style&index=0&id=956df6d6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-956df6d6"]])

export default __exports__